import { useEffect, useRef } from 'react';

import { getVisitorPresenceUpdateIntervalMs } from '../../config';
import { useUpdateVisitorPresenceCallback } from './useUpdateVisitorPresenceCallback';

// TODO: TREE-326 don't show client to provider until they're admittable i.e. connected
// to Twilio sync and are watching the visitor access map
export function useUpdateVisitorPresenceInterval() {
  const updateVisitorPresence = useUpdateVisitorPresenceCallback();
  const intervalRef = useRef<NodeJS.Timeout>();

  useEffect(
    function continuouslyUpdateVisitorPresence() {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      updateVisitorPresence();

      intervalRef.current = setInterval(updateVisitorPresence, getVisitorPresenceUpdateIntervalMs());

      return function cleanup() {
        clearInterval(intervalRef.current);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}
